import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {Link} from "react-router-dom";

export default function WifiForventningerArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Det er umuligt at garantere en hastighed på wifi-signalet, da mange faktorer i hjemmet har indflydelse på signalet.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad kan vi garantere på wifi?</h2>
                        <p>
                            På wifi kan vi ikke garantere en specifik hastighed, da mange faktorer kan påvirke signalet.
                        </p>
                        <p>
                            Routeren sender et trådløst signal, og det samme gør din enhed.
                            Routerens og enhedens netværkskort kommunikerer gennem signalerne, og kommunikationen afgør signalets kvalitet (dvs. hastigheden på dit wifi og routerens rækkevidde).
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad kan jeg forvente på rækkevidden af mit wifi?</h2>
                        <p>
                            Rækkevidden afhænger af din boligs fysiske rammer og kan begrænses af mange elementer.
                            F.eks. har routerens signalstyrke, antennetype, routerens placering og de fysiske roller i hjemmet stor indflydelse på dit wifi.
                        </p>
                        <p>
                            Betonvægge, termoruder med indbygget solafskærmning samt armeringsstål i vægge og gulve virker også dæmpende på wifi-signalet.
                        </p>
                        <p>
                            <strong>Sørg for at placere din router et godt sted i din bolig.</strong><br/>
                            Så sikrer du det bedst mulige wifi i din bolig.
                            Læs mere <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}
                            >her</Link>.
                        </p>
                    </div>
                    <img
                        className="paragraph-image no-br"
                        src={imageMap.help.network.materialer}
                        alt="Grafik af materialer som påvirker signalstyrken på wifi."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Brug routerens 2,4- og 5 GHz-netværk optimalt</h2>
                        <p>
                            Som tommelfingerregel rækker 2,4 GHz omkring 10 meter, og 5 GHz op til 5 meter.
                            Derfor anbefaler vi, at du bruger 2,4 GHz, når du befinder dig længere væk fra routeren, og du bør bruge 5 GHz-netværket, når du befinder dig tæt på routeren.
                        </p>
                        <p>
                            Du kan læse mere om forskellen på 2,4 og 5 GHz lige <Link to={'/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser'}
                            >her</Link>.
                        </p>
                    </div>
                    <img
                        className="paragraph-image no-br"
                        src={imageMap.help.network.raekkevidde}
                        alt="Grafik af plantegninger der sammenligner 2,4 og 5 GHz signalstyrke og -hastighed."
                    />
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "hastighedstest",
                        "name": "Hastighedstest"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4 GHz og 5 GHz"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    }
                ]}
            />
        </>
    )
}
